import styled from 'styled-components'

export const ProductDetailsWrapperSkeleton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1.5rem 1rem 0 1rem;
`

export const ProductDescriptionsWrapperSkeleton = styled.div`
  width: 75%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: space-between;
`

export const PriceRowSkeleton = styled.div`
  width: 25%;
`

export const VariantsSliderSkeleton = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.3rem;
  height: 9.5rem;
  margin-top: 0.75rem;
  overflow: hidden;
  max-width: 100%;

  @media screen and (min-width: 768px) {
    margin-left: 1rem;

    span:nth-child(5),
    span:nth-child(6) {
      display: none;
    }
  }
`

export const ApparelCard = styled.div<{ layout?: 'card' | 'list' }>`
  ${({ layout, theme }) =>
    layout === 'list' &&
    `
    display: grid;
    grid-template-columns: minmax(auto, 26.5%) auto;
    height: fit-content;
    padding: 1.2rem 0;
    border-bottom: 1px solid ${theme.colors.secondary};

    &:first-child {
      padding-top: 0;
    }
  `}

  width: 100%;
  text-align: left;

  span {
    line-height: 2.2rem;
  }
`

export const Image = styled.div`
  .react-loading-skeleton {
    aspect-ratio: 4/5;

    .safari-lower-than-15 & {
      padding-top: 125%;
    }
  }
`

export const Title = styled.div`
  .react-loading-skeleton {
    height: 3rem;
    width: 70%;

  }

    @media (min-width: 768px) {
      .react-loading-skeleton {
        height: 2.2rem;
        width: 75%;
      }
    }
  }
`

export const ProductType = styled.div`
  .react-loading-skeleton {
    width: 80%;
    height: 1.5rem;
  }
`

export const Season = styled.div`
  margin-bottom: 1rem;

  .react-loading-skeleton {
    width: 65%;
    height: 1.6rem;
  }
`

export const Description = styled.div`
  .react-loading-skeleton {
    height: 1.5rem;
  }
`

export const Price = styled.div`
  margin-bottom: 1.5rem;
  text-align: right;

  .react-loading-skeleton {
    width: 95%;
    height: 1.8rem;
  }
`

export const Separator = styled.div`
  height: 1px;
  width: 100%;
  background: ${({ theme }) => theme.colors.disabled};
  margin: auto auto 1rem auto;
`
